import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Logo, Skeleton } from "../UI/Primitives";
import { syncCityFromUrl } from "../../Service/endpoints";

// Resets scroll on forward navigation; back/forward keeps the browser's position.
export function ScrollToTop() {
  const { pathname } = useLocation();
  const history = useHistory();
  useEffect(() => {
    if (history.action !== "POP") window.scrollTo(0, 0);
    syncCityFromUrl();
  }, [pathname, history]);
  return null;
}

// Shown while a route chunk loads: mirrors the header so nothing jumps.
export function PageFallback() {
  return (
    <div aria-busy="true" aria-label="Loading page">
      <div className="v-header-spacer" />
      <div className="v-header">
        <div className="v-header__inner">
          <Logo height={24} />
        </div>
      </div>
      <div className="v-container" style={{ paddingTop: "var(--space-8)" }}>
        <Skeleton width="30%" height="14px" />
        <Skeleton width="55%" height="40px" style={{ marginTop: "var(--space-4)" }} />
        <Skeleton width="100%" height="320px" radius="var(--radius-lg)" style={{ marginTop: "var(--space-8)" }} />
      </div>
    </div>
  );
}

// Remount a page whenever its URL changes. Pages read route params in their
// constructor (as they did with full page loads), so this preserves behaviour
// while allowing client-side navigation.
export function keyedByPath(Component) {
  function KeyedRoute(props) {
    return <Component key={props.location.pathname} {...props} />;
  }
  return KeyedRoute;
}
